module.exports = __webpack_public_path__ + "static/media/magento_logo.a978da06.png";